const indentWidthsByLevel = [0, 20, 36];
type IndentLevel = 0 | 1 | 2;

const smWidth = 300;
const mdWidth = 440;
const lgWidth = 550;

type WidthValue = string | number;

/**
 * The way in which the accordion rows are constructed makes it
 * extremely difficult to manage indentation effectively right now.
 * In order to clean it up, we probably need to unfurl the entire
 * thing and re-do it in a less fragile way. (If you're considering
 * working with the existing fragile system rather than trying to
 * refactor it away, do so at your own peril. Consider yourself
 * warned!) -scotty
 *
 * In the meantime, we use this utility - dense and incomprehensible
 * though it may be - to at least centralize the nonsense.
 */
export function getExplorerIndentedWidth({
  indentLevel,
  indentOffset = 0,
}: {
  indentLevel: IndentLevel;
  indentOffset?: number;
}): { base: WidthValue; sm: WidthValue; md: WidthValue; lg: WidthValue } {
  const totalIndentWidth = indentWidthsByLevel[indentLevel] - indentOffset;
  return {
    // VERY LEAKY, but the RangeBars are hidden at this breakpoint so we
    // can render content without constraining or clipping. (Use calc to
    // limit width for some breathing room.)
    base: "calc(100% - 16px)",

    sm: smWidth - totalIndentWidth,
    md: mdWidth - totalIndentWidth,
    lg: lgWidth - totalIndentWidth,
  };
}
